import { render } from "./SessionAddPlayers.vue?vue&type=template&id=7ec6836c&scoped=true"
import script from "./SessionAddPlayers.vue?vue&type=script&lang=js"
export * from "./SessionAddPlayers.vue?vue&type=script&lang=js"

import "./SessionAddPlayers.vue?vue&type=style&index=0&id=7ec6836c&scoped=true&lang=css"

import exportComponent from "C:\\BiggerInside\\Protocol223-Portal\\portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec6836c"]])

export default __exports__